import { Slider } from 'antd'
import React, { FunctionComponent, useCallback, useEffect, useMemo, useRef } from 'react'
import { browserInfo, throttle } from 'src/utils/tools'
import api from './packages/api'
import FURenderKitSDK from './packages/sdk/fu_render_kit'
import { FUResourceManager } from './packages/sdk/fu_resource_manager'

interface BundleRenderProps {
    mode?: string
    lightUrl: string
    bundleUrl: string
    cameraUrl: string
    bundleMax: number
    bundleMin: number
    backgroundUrl: string
    isFull: boolean
    bundleDom: any
    onCallback?: Function
}

const BundleRender: FunctionComponent<BundleRenderProps> = props => {
    let requestAnimationFrameId
    const { bundleDom } = props
    const canvasDom = useRef(null)
    const currentMultiple = useRef<number>()
    const initMultiple = useRef(1)

    const relativeMax = useMemo(() => {
        return props.bundleMax * initMultiple.current
    }, [props.bundleMax, initMultiple.current])
    const relativeMin = useMemo(() => {
        return props.bundleMin * initMultiple.current
    }, [props.bundleMax, initMultiple.current])

    useEffect(() => {
        const value = window.devicePixelRatio
        let width, height
        if (props.mode === 'pc') {
            // width = window.screen.width
            // height = window.screen.height
            // width = window.screen.availWidth
            // height = window.screen.availHeight
            // width = window.outerWidth
            // height =  window.outerHeight
            width = document.body.clientWidth
            height = document.body.clientHeight
        } else {
            width = bundleDom.current.clientWidth
            height = bundleDom.current.clientHeight
        }

        canvasDom.current.width = width * value
        canvasDom.current.height = height * value
        canvasDom.current.style.height = height + 'px'
        canvasDom.current.style.width = width + 'px'
        bundleSdk()

        return () => {
            if (sdk) {
                window.cancelAnimationFrame(requestAnimationFrameId)
                sdk.RenderKit.destroyInstance()
            }
        }
    }, [])

    /////
    const sdk = new FURenderKitSDK({
        locateFile: path => {
            return `https://objectx-prod.oss-cn-hangzhou.aliyuncs.com/objectx/websdk/release/1.7.0/${path}`
        },
    })
    const resourceManager = new FUResourceManager({
        api,
        projectid: 'projectId',
        projectVersion: '0.0.1',
        cacheLimit: 10,
    })

    let originX
    let originRotationX = 0,
        middle = false
    let moving = false,
        touching = false
    let touchStartPos = { x: -1, y: -1 }
    const globalRenderer = useRef(null)
    let avatar, originRotation, globalScene, camera, previousFrameTimestamp
    // useEffect(() => {
    //     let width, height
    //     const value = window.devicePixelRatio
    //     if (props.isFull) {
    //         width = window.screen.width
    //         height = window.screen.height
    //     } else {
    //         width = document.body.clientWidth
    //         height = document.body.clientHeight
    //     }
    //     canvasDom.current.width = width * value
    //     canvasDom.current.height = height * value
    //     canvasDom.current.style.height = height + 'px'
    //     canvasDom.current.style.width = width + 'px'
    //     globalRenderer.current &&
    //         globalRenderer.current.resize(canvasDom.current.width, canvasDom.current.height)
    // }, [props.isFull, globalRenderer])
    useEffect(() => {
        const value = window.devicePixelRatio
        let width, height
        if (props.isFull) {
            const isLandscape = Math.abs(window.orientation) === 90
            if (isLandscape) {
                width = window.screen.height
                height = window.screen.width
            } else {
                width = window.screen.width
                height = window.screen.height
            }
        } else {
            width = document.documentElement.clientWidth
            height = document.documentElement.clientHeight
        }
        canvasDom.current.width = width * value
        canvasDom.current.height = height * value
        canvasDom.current.style.width = width + 'px'
        canvasDom.current.style.height = height + 'px'
        globalRenderer.current &&
            globalRenderer.current.resize(canvasDom.current.width, canvasDom.current.height)
    }, [props.isFull, globalRenderer])

    const touchMoveRotateHandler = useCallback(target => {
        let clientX, clientY
        if (browserInfo.versions.mobile || browserInfo.versions.iPad) {
            clientX = target.changedTouches[0].clientX
            clientY = target.changedTouches[0].clientY
        } else {
            clientX = target.clientX
            clientY = target.clientY
        }
        if (touchStartPos.x === -1) {
            touchStartPos.x = clientX
            touchStartPos.y = clientY
            return
        }
        let distence = {
            x: clientX - touchStartPos.x,
            y: clientY - touchStartPos.y,
        }
        touchStartPos.x = clientX
        touchStartPos.y = clientY
        if (avatar) {
            const sensitive = 0.5
            avatar.setDeltaRotation([1, 0, 0], sensitive * distence.y)
            avatar.setDeltaRotation([0, 1, 0], sensitive * distence.x)
            bundleRender()
        }
    }, [])

    let waitZoom = false
    const store = {} as any
    const multipleCalc = (zoom, value) => {
        if (zoom > 0) {
            currentMultiple.current = currentMultiple.current * (1 + value || 0.2)
        } else {
            currentMultiple.current = currentMultiple.current * (1 - value || 0.2)
        }
        if (currentMultiple.current > relativeMax || currentMultiple.current < relativeMin) {
            if (zoom > 0) {
                currentMultiple.current = relativeMax
            } else {
                currentMultiple.current = relativeMin
            }
        }
        avatar.setScale([currentMultiple.current, currentMultiple.current, currentMultiple.current])
    }

    useEffect(() => {
        // 一碰就炸
        canvasDom.current.addEventListener('touchstart', function (event) {
            if (event.touches && event.touches.length == 2) {
                store.moveable = true
                const touches = event.touches
                const events = touches[0]
                const events2 = touches[1]
                store.preDistance = Math.hypot(
                    events2.pageX - events.pageX,
                    events2.pageY - events.pageY,
                )
            }
        })
        canvasDom.current.addEventListener('touchmove', function (event) {
            if (!store.moveable) {
                return
            }

            moving = false

            event.preventDefault()

            const touches = event.touches
            const events = touches[0]
            const events2 = touches[1]

            const t1 = Math.hypot(events2.pageX - events.pageX, events2.pageY - events.pageY)
            const t2 = store.preDistance

            if (t1 && t2) {
                let zoom
                if (t1 > t2) {
                    zoom = 1
                } else {
                    zoom = -1
                }
                if (camera) {
                    multipleCalc(zoom, 0.02)
                }
                waitZoom = true
                setTimeout(function () {
                    waitZoom = false
                }, 0)
            }
            store.preDistance = t1
            // 双指移动
        })

        canvasDom.current.addEventListener('touchend', function () {
            store.moveable = false
            delete store.preDistance
        })
        canvasDom.current.addEventListener('touchcancel', function () {
            store.moveable = false
            delete store.preDistance
        })

        if (navigator.userAgent.indexOf('Chrome') > -1) {
            ;(document as any).onmousewheel = function (event) {
                if (props.mode === 'pc' && !waitZoom) {
                    let zoom = event.wheelDelta

                    if (avatar) {
                        multipleCalc(zoom, 0.2)
                    }
                    waitZoom = true
                    setTimeout(function () {
                        waitZoom = false
                    }, 50)
                }
            }
        } else {
            ;(document as any).onwheel = function (event) {
                if (props.mode === 'pc' && !waitZoom) {
                    let zoom = event.wheelDelta

                    if (avatar) {
                        multipleCalc(zoom, 0.2)
                    }
                    waitZoom = true
                    setTimeout(function () {
                        waitZoom = false
                    }, 50)
                }
            }
        }
    }, [])

    const bundleRender = () => {
        if (globalRenderer) {
            globalRenderer.current.render(globalScene, 0)
        }
    }
    function startRenderLoop() {
        props?.onCallback()
        previousFrameTimestamp = performance.now()
        tick(performance.now())
    }

    let interval = 0
    function draw(timestamp) {
        const elapsed = timestamp - previousFrameTimestamp
        if (elapsed >= interval) {
            previousFrameTimestamp = timestamp
            rotate(elapsed)
        }
    }

    function tick(timestamp) {
        requestAnimationFrameId = window.requestAnimationFrame(tick)
        draw(timestamp)
    }

    function rotate(elapsed) {
        if (avatar) {
            const rotation = avatar.getRotation()
            !touching &&
                avatar.setRotation([
                    rotation[0],
                    rotation[1] + (360 / 30000) * elapsed,
                    rotation[2],
                ])
            bundleRender()
        }
    }

    const bundleSdk = async () => {
        const sdkReady = sdk.initialize()
        const results = await Promise.all([sdkReady])
        const authResult = await sdk.authWithAuthpack(
            'authpack.bin',
            resourceManager.auth.bind(resourceManager),
        )
        globalRenderer.current = sdk.RenderKit.getInstance()
        globalRenderer.current.init({
            canvas: canvasDom.current,
            explicitSwapControl: false,
        })

        // 配置资源管理
        globalRenderer.current.setFUResourceManager(resourceManager)
        // 创建 scene
        globalScene = globalRenderer.current.createScene()

        globalScene.setRenderMsaaLevel(sdk.EMSAAOption.MSAA_NONE)
        globalScene.enableRenderPostProcess(sdk.EPostProcessType.POST_PROCESS_FXAA, true)

        globalScene.enableRenderPostProcess(sdk.EPostProcessType.POST_PROCESS_MIRROR, false)

        const pixels = new Uint8Array(200 * 200 * 4)
        for (let i = 0; i < pixels.byteLength; i++) {
            if (i % 4 === 3 || i % 4 === 0) {
                pixels[i] = 255
            }
        }

        await resourceManager.prepareCustomBundle(props.backgroundUrl, 'background.bundle')
        globalScene.setBackgroundSync('background.bundle')

        const lightUrl = props.lightUrl
        await resourceManager.prepareCustomBundle(lightUrl, 'Light.bundle')
        globalScene.setLightSync('Light.bundle')

        const camurl = props.cameraUrl
        await resourceManager.prepareCustomBundle(camurl, 'Camera.bundle')
        camera = globalScene.setCameraSync('Camera.bundle')

        // 加载初始 avatar
        avatar = globalScene.addAvatar()

        const bundleUrl = props.bundleUrl

        const objectP = resourceManager.downloadAsset(bundleUrl)
        bundleRender()
        const objArrayBuffer = await objectP
        const bundle = sdk.writeAssets(objArrayBuffer)
        let avatarItem = new sdk.wasmCtx.module.FUAvatarItem(
            bundle.ptr,
            bundle.size,
            'cloth014.bundle',
            'cloth014.bundle',
        )
        sdk.wasmCtx.module._free(bundle.ptr)
        avatar.addItem(avatarItem)
        initMultiple.current = avatar.getScale()[0]

        currentMultiple.current = avatar.getScale()[0]

        bundleRender()
        startRenderLoop()

        let throttleRotateHandler = throttle(touchMoveRotateHandler, 10)
        if (browserInfo.versions.mobile || browserInfo.versions.iPad) {
            canvasDom.current.ontouchstart = function (event) {
                touchStartPos = { x: -1, y: -1 }
                moving = touching = true
            }
            canvasDom.current.ontouchmove = function (event) {
                if (!moving) {
                    return
                }
                throttleRotateHandler(event)
            }
            canvasDom.current.ontouchend = function () {
                moving = false
            }
        } else {
            canvasDom.current.onmousedown = function (event) {
                if (event.button == 1) {
                    middle = true
                    moving = false
                    touching = true
                    return
                }
                touchStartPos = { x: -1, y: -1 }
                moving = touching = true
            }

            canvasDom.current.onmousemove = function (event) {
                if (middle) {
                    const { movementX, movementY } = event
                    avatar.setDeltaPosition([movementX, -movementY, 0])
                }
                if (!moving) {
                    return
                }
                throttleRotateHandler(event)
            }
            canvasDom.current.onmouseup = function (event) {
                if (event.button == 1) {
                    middle = false
                }
                moving = false
            }
        }
    }

    return (
        <canvas
            ref={canvasDom}
            className="emscripten"
            id="canvas"
            contextMenu="event.preventDefault()"
        ></canvas>
    )
}
BundleRender.defaultProps = {
    bundleMax: 2,
    bundleMin: 0.3,
}
export default BundleRender
